<template>
  <div>
    <!-- <GlobalTable
      :enableAddButton ="false"
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :addButtonNeed="addButtonNeed"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
           <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
// import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "Complaint",
  components: { Loading, JqxGrid, TableButton },
  data() {
    return {
      title: "Keluhan",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "order_number", type: "string" },
          { name: "payment_method_name", type: "string" },
          { name: "status_name", type: "string" },
          { name: "total", type: "float" },
          { name: "complaint_type_name", type: "string" },
          { name: "user_name", type: "string" },
          { name: "date_inserted", type: "date" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "order_number",
          columntype: "textbox",
          filtertype: "textbox",
          text: "No. Pesanan",
        },
        {
          datafield: "payment_method_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Metode Pembayaran",
        },
        {
          datafield: "status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
        },
        {
          datafield: "total",
          columntype: "numberinput",
          filtertype: "textbox",
          text: "Total",
          cellsformat: "c2",
          cellsalign: "right",
          align:"right",
          width:150,
        },
        {
          datafield: "complaint_type_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Tipe Keluhan",
        },
        {
          datafield: "user_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Dikirim Oleh",
        },

        {
          datafield: "date_inserted",
          columntype: "datetimeinput",
          filtertype: "date",
          text: "Tanggal Input",
          cellsformat: "d",
          cellsalign: "right",
          align:"right"
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        }
      ],

      listBoxSource: [
        {
          label: "Tanggal Input",
          value: "date_inserted",
          checked: true,
        },
        {
          label: "Total",
          value: "total",
          checked: true,
        },
      ],

      items: null,
      isLoading: false,
      isEdit: false,

      addButtonNeed:false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getProductListing();
    },
    getProductListing: function () {
      this.isLoading = true;
      this.axios
        .get("console/complaint/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            // this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.productForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.products) {
        tableInterfaces.products[i] = null;
      }
      this.productForm = tableInterfaces.products;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
